import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useWaveLeaderboardRendererSet } from "../leaderboardRendererRegistry";
interface WaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly onSourceDropDeleted?: (() => void) | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export const WaveLeaderboardDrop: React.FC<WaveLeaderboardDropProps> = t0 => {
  const $ = _c(9);
  const {
    drop,
    wave,
    onDropClick,
    onSourceDropDeleted,
    isVotingClosed: t1,
    isVotingControlsLocked: t2
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const isVotingControlsLocked = t2 === undefined ? false : t2;
  const {
    LeaderboardDrop
  } = useWaveLeaderboardRendererSet(wave.id);
  const winningThreshold = wave.wave.type === ApiWaveType.Approve ? wave.wave.winning_threshold : null;
  let t3;
  if ($[0] !== LeaderboardDrop || $[1] !== drop || $[2] !== isVotingClosed || $[3] !== isVotingControlsLocked || $[4] !== onDropClick || $[5] !== onSourceDropDeleted || $[6] !== wave || $[7] !== winningThreshold) {
    t3 = <LeaderboardDrop drop={drop} wave={wave} onDropClick={onDropClick} onSourceDropDeleted={onSourceDropDeleted} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} winningThreshold={winningThreshold} />;
    $[0] = LeaderboardDrop;
    $[1] = drop;
    $[2] = isVotingClosed;
    $[3] = isVotingControlsLocked;
    $[4] = onDropClick;
    $[5] = onSourceDropDeleted;
    $[6] = wave;
    $[7] = winningThreshold;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};